import { Priority, TicketStatus } from "../enums";

export class GetTicketsForBoardInput {
    public departmentIds = new Array<number>();
    public assignedTo: number | null = null;
    public priority: Priority | null = null;
    public customerId: number | null = null;
    public projectId: number | null = null;
    public ticketStatus: TicketStatus | null = null;
    public tagIds: Array<number> = new Array<number>();
}
